import useDataCollection from "../../../hooks/useDataCollection";
import InvestorSelection from "./CommonComponents/00-InvestorSelection";
import InvestorData from "./LegalEntity/01-InvestorData";
import useDataCollectionSetlists from "../../..//hooks/useDataCollectionSetlists";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import BeneficialOwners from "./LegalEntity/02-BeneficialOwners";
import Representatives from "./LegalEntity/03-Representatives";
import LegalEntityContacts from "./LegalEntity/04-Contacts";
import useDataCollectionOCR from "../../../hooks/useDataCollectionOCR";
import SignatoryData from "./PhysicalPerson/01-SignatoryData";
import SignatoryActivity from "./PhysicalPerson/02-SignatoryActivity";
import PhysicalPersonContacts from "./PhysicalPerson/03-Contacts";
import { IDataCollectionProps } from "./IDataCollection";

const DataCollection = (props: IDataCollectionProps ) => {
  const { translations, language, navigate, setHasDataToComplete } = props;

  const {
    investorsList,
    personType,
    onChangeInvestor,
    step,
    advanceStep,
    goBackStep,
    selectedInvestor,
    setSelectedInvestor,
    onAddItem,
    onRemoveItem,
    handleAutocomplete,
    handleAutocompleteContacts,
    hasErrors,
	isFetchingData,
} = useDataCollection({ translations, navigate, setHasDataToComplete });
const {
    countries,
    activitySectors,
    lastExcerciseIncomes,
    lastExcerciseNetWorths,
    foundsOrigin,
	positions,
	communicationTypes,
	activityOptions
  } = useDataCollectionSetlists();

  const { isOcrLoading, handleBeforeUpload } = useDataCollectionOCR({
    onChangeInvestor,
  });
  
  return (
    <div className="data-recolection-container">
      {/* STEP 0 */}
      {step === 0 && (
        <InvestorSelection
          translations={translations}
          investorsList={investorsList}
          onChangeInvestor={onChangeInvestor}
          advanceStep={advanceStep}
          selectedInvestor={selectedInvestor}
		  navigate={navigate}
		  isFetchingData={isFetchingData}
        />
      )}

      <Spin
        spinning={isFetchingData}
        fullscreen
        indicator={
          <LoadingOutlined style={{ fontSize: 34, color: "black" }} spin />
        }
      />
      {/* LEGAL ENTITY */}
      {/* STEP 1 */}
      {personType === 2 && step === 1 && (
        <InvestorData
          language={language}
          selectedInvestor={selectedInvestor}
          advanceStep={advanceStep}
          onChangeInvestor={onChangeInvestor}
          setSelectedInvestor={setSelectedInvestor}
          activitySectors={activitySectors}
          lastExcerciseIncomes={lastExcerciseIncomes}
          lastExcerciseNetWorths={lastExcerciseNetWorths}
          foundsOrigin={foundsOrigin}
          countries={countries}
          translations={translations}
          onAddItem={onAddItem}
          onRemoveItem={onRemoveItem}
          errors={hasErrors?.[step]?.[personType] || {}}
          isOcrLoading={isOcrLoading}
          handleBeforeUpload={handleBeforeUpload}
        />
      )}
      {/* LEGAL ENTITY */}
      {/* STEP 2 */}
      {personType === 2 && step === 2 && (
        <BeneficialOwners
          selectedInvestor={selectedInvestor}
          advanceStep={advanceStep}
          goBackStep={goBackStep}
          onChangeInvestor={onChangeInvestor}
          translations={translations}
          countries={countries}
          onAddItem={onAddItem}
          onRemoveItem={onRemoveItem}
          errors={hasErrors?.[step]?.[personType] || {}}
          isOcrLoading={isOcrLoading}
          handleBeforeUpload={handleBeforeUpload}
		  language={language}
        />
      )}
      {/* LEGAL ENTITY */}
      {/* STEP 3 */}
      {personType === 2 && step === 3 && (
        <Representatives
          selectedInvestor={selectedInvestor}
          advanceStep={advanceStep}
          goBackStep={goBackStep}
          onChangeInvestor={onChangeInvestor}
          translations={translations}
          countries={countries}
          onAddItem={onAddItem}
          onRemoveItem={onRemoveItem}
          handleAutocomplete={handleAutocomplete}
          errors={hasErrors?.[step]?.[personType] || {}}
          isOcrLoading={isOcrLoading}
          handleBeforeUpload={handleBeforeUpload}
		  language={language}
        />
      )}
      {/* LEGAL ENTITY */}
      {/* STEP 4 */}
      {personType === 2 && step === 4 && (
        <LegalEntityContacts
          selectedInvestor={selectedInvestor}
          goBackStep={goBackStep}
          onChangeInvestor={onChangeInvestor}
          translations={translations}
          onAddItem={onAddItem}
          onRemoveItem={onRemoveItem}
          advanceStep={advanceStep}
          handleAutocompleteContacts={handleAutocompleteContacts}
          errors={hasErrors?.[step]?.[personType] || {}}
		  communicationTypes={communicationTypes}
		  language={language}
        />
      )}

      {/* PHYSICAL PERSON */}
      {/* STEP 1 */}
      {personType === 1 && step === 1 && (
        <SignatoryData
          selectedInvestor={selectedInvestor}
          advanceStep={advanceStep}
          onChangeInvestor={onChangeInvestor}
          translations={translations}
          onAddItem={onAddItem}
          onRemoveItem={onRemoveItem}
          errors={hasErrors?.[step]?.[personType] || {}}
          isOcrLoading={isOcrLoading}
          handleBeforeUpload={handleBeforeUpload}
          goBackStep={goBackStep}
		  setSelectedInvestor={setSelectedInvestor}
		  foundsOrigin={foundsOrigin}
		  language={language}
		  countries={countries}
        />
      )}

      {/* PHYSICAL PERSON */}
      {/* STEP 2 */}
      {personType === 1 && step === 2 && (
        <SignatoryActivity
          selectedInvestor={selectedInvestor}
          advanceStep={advanceStep}
          onChangeInvestor={onChangeInvestor}
          translations={translations}
          errors={hasErrors?.[step]?.[personType] || {}}
          goBackStep={goBackStep}
		  activitySectors={activitySectors}
		  lastExcerciseIncomes={lastExcerciseIncomes}
		  positions={positions}
		  language={language}
		  activityOptions={activityOptions}
        />
      )}

      {/* PHYSICAL PERSON */}
      {/* STEP 3 */}
      {personType === 1 && step === 3 && (
        <PhysicalPersonContacts
          selectedInvestor={selectedInvestor}
          goBackStep={goBackStep}
          onChangeInvestor={onChangeInvestor}
          translations={translations}
          onAddItem={onAddItem}
          onRemoveItem={onRemoveItem}
          advanceStep={advanceStep}
          handleAutocompleteContacts={handleAutocompleteContacts}
          errors={hasErrors?.[step]?.[personType] || {}}
		  communicationTypes={communicationTypes}
		  language={language}
        />
      )}
    </div>
  );
};

export default DataCollection;
